// components/TypingIndicator.jsx
import React from "react";

function TypingIndicator({ background = "bg-white" }) {
  return (
    <div className={`d-flex align-items-center px-3 py-2 ${background} rounded-4`} style={{ maxWidth: "80px", gap: "4px" }}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="bg-secondary rounded-circle"
          style={{
            width: "10px",
            height: "10px",
            animation: `bounce 1.5s infinite`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% {
              transform: scale(0.6);
              opacity: 0.5;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TypingIndicator;
